<template>
  <div class="inspection-second">
    <div class="inspection-content">
      <!-- <div class="index-bar">
        <div class="name active">基本信息</div>
        <div class="name" v-for="(item, index) in checkItems" :key="index">
          {{ item.name }}
        </div>
        <div class="name">问题图片</div>
        <div class="name">建议</div>
      </div> -->
      <div class="content">
        <div class="item">
          <div class="title">基本信息</div>
          <div class="details">
            <div class="user-info">
              客户需求：{{ vehicleCheckReport.demandName }}
            </div>
            <div class="user-info">检测人：{{ clerk }}</div>
            <div class="user-info">
              车牌号：{{ vehicleCheckReport.plateNum }}
            </div>
          </div>
        </div>
        <div class="item" v-for="(items, indexs) in checkItems" :key="indexs">
          <div class="title">{{ items.name }}</div>
          <div
            class="details-check-item"
            v-for="(item, index) in items.subItems"
            :key="index"
          >
            <div class="name">{{ item.name }}</div>
            <van-radio-group
              class="option"
              v-model="checkItems[indexs].subItems[index].checkResult"
              direction="horizontal"
            >
              <van-radio :name="1" checked-color="green"> 正常 </van-radio>
              <van-radio :name="0" checked-color="red"> 异常 </van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="item">
          <div class="title issue-img">问题图片(选填)</div>
          <div class="details">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="4"
              :after-read="afterRead"
              :before-delete="beforeDelete"
              :before-read="beforeRead"
            />
          </div>
        </div>
        <div class="item">
          <div class="title advise-title">检修建议(选填)</div>
          <div class="details">
            <van-field
              class="advice"
              v-model="form.remark"
              rows="6"
              autosize
              type="textarea"
              placeholder="请填写车辆检修建议"
            />
          </div>
        </div>
      </div>
    </div>
    <van-button
      class="inspection-send"
      type="primary"
      @click="handleSend"
      :loading="subStatus"
    >
      将检测报告发送给车主
    </van-button>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import { checkItemList, vehicleCheckReport } from "@/api/inspection";
import * as imageConversion from "image-conversion";
export default {
  data() {
    return {
      vehicleCheckReport: JSON.parse(
        localStorage.getItem("vehicleCheckReport")
      ),
      fileList: [],
      checkItems: [],
      pics: [],
      subStatus: false,
      clerk: JSON.parse(sessionStorage.getItem("userInfo")).nickname,
      form: {
        userPhone: "",
        plateNum: "",
        checkUserId: "",
        customerDemand: "",
        remark: "",
        pic: "",
        checkItems: []
      }
    };
  },
  mounted() {
    this.handleCheckItemList();
  },
  methods: {
    // 检测项目
    handleCheckItemList() {
      checkItemList().then(res => {
        // console.log("检测项目 :>> ", res);
        res.forEach(val => {
          this.vehicleCheckReport.checkItems.forEach(element => {
            if (val.id === element) {
              this.checkItems.push(val);
            }
          });
        });
      });
    },
    // 上传图片前
    beforeRead(file) {
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 300;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 300).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then(res => {
          file.status = "done";
          file.message = "上传成功";
          this.pics.push(res.url);
        })
        .catch(err => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          this.$toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      this.fileList.splice(detail.index, 1);
      this.pics.splice(detail.index, 1);
    },
    // 提交
    handleSend() {
      this.subStatus = true;
      if (!this.handleFormVerify()) {
        this.subStatus = false;
        return;
      }
      this.form.pic = this.pics.length === 0 ? "" : this.pics.join(",");
      this.form.userPhone = this.vehicleCheckReport.userPhone;
      this.form.plateNum = this.vehicleCheckReport.plateNum;
      this.form.checkUserId = JSON.parse(
        sessionStorage.getItem("userInfo")
      ).userId;
      this.form.customerDemand = this.vehicleCheckReport.customerDemand;
      this.form.checkItems = this.checkItems;
      vehicleCheckReport(this.form).then(res => {
        this.subStatus = false;
        if (res.code === 0) {
          this.$toast("发送成功");
          setTimeout(() => {
            wx.closeWindow();
          }, 500);
        }
      });
    },
    // 表单校验
    handleFormVerify() {
      let verifyResult = true;
      this.checkItems.forEach(val => {
        for (const element of val.subItems) {
          if (!("checkResult" in element)) {
            verifyResult = false;
            console.log(123);
            return false;
          }
        }
      });
      if (!verifyResult) {
        this.$toast("请勾选检测项目");
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.inspection-second {
  .inspection-content {
    display: flex;

    .index-bar {
      flex: 2;

      .name {
        height: 30px;
        line-height: 30px;
      }

      .active {
        border-bottom: 1px solid red;
      }
    }

    .content {
      flex: 5;
      padding: 0 10px;

      .item {
        .title {
          padding: 10px 0;
          text-align: left;
          border-bottom: 1px solid #c0c0c0;
          font-size: 16px;
          font-weight: 600;
          color: blue;
        }

        .issue-img,
        .advise-title {
          border-bottom: none;
        }

        .details {
          padding: 5px;
          text-align: left;
          font-size: 14px;

          .user-info {
            padding: 5px 0;
          }

          .advice {
            border: 1px solid #c0c0c0;
          }
        }

        .details-check-item {
          display: flex;
          padding: 5px;
          text-align: left;

          .name {
            flex: 1;
            padding: 5px 0;
            font-size: 14px;
          }

          .option {
            flex: 2;
            padding: 5px 0;
            justify-content: space-around;
            font-size: 14px;
          }
        }
      }
    }
  }

  .inspection-send {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
